{
  "brandingLogoPath": "assets/images/PASM-logo.svg",
  "brandingTitle": "GU Portal",
  "theme": "light",
  "language": "de-DE",
  "support": {
    "affinis": "support-pasm@affinis.de",
    "pasm": "PASM-EnergySupplyMobile@pasm.de"
  }
}
